import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link as ReactRouterLink } from "react-router-dom";
import Link from "@mui/material/Link";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import {
  logout,
  selectIsLoggedIn,
  selectUser,
} from "../../features/user/userSlice";

function Navbar() {
  const dispatch = useDispatch();
  const isLoggedIn = useSelector(selectIsLoggedIn);
  const currentUser = useSelector(selectUser);
  // console.log("Navbar: isLoggedIn: ", isLoggedIn);
  // console.log("Navbar: currentUser: ", currentUser);

  return (
    <Box
      component="nav"
      sx={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        px: 2,
        py: 1,
        borderBottom: "1px solid #ccc",
      }}
    >
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Link component={ReactRouterLink} to="/" sx={{ mr: 2 }}>
          Home
        </Link>
        {isLoggedIn && (
          <>
            <Link
              to="/registered/team"
              component={ReactRouterLink}
              sx={{ mr: 2 }}
            >
              Team
            </Link>
            <Link to="/registered/user-profile" component={ReactRouterLink}>
              User Profile
            </Link>
          </>
        )}
      </Box>
      {isLoggedIn ? (
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Typography variant="body2" sx={{ mr: 2 }} display="inline">
            {currentUser.$id} | {currentUser.name}
          </Typography>
          <Button
            variant="outlined"
            size="small"
            onClick={() => dispatch(logout())}
          >
            Logout
          </Button>
        </Box>
      ) : (
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Link to="/sign-in" component={ReactRouterLink} sx={{ mr: 2 }}>
            Sign in
          </Link>
          <Link to="/sign-up" component={ReactRouterLink}>
            Sign up
          </Link>
        </Box>
      )}
    </Box>
  );
}

export default Navbar;
